module.exports = __webpack_public_path__ + "img/1.37f4e72b.jpg";